const initialState = {
    responseCurrenciesList: [],
    responseCurrency: []
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "CURRENCIES_RESPONSE_LIST":
            
            if (action.value.detail !== undefined)
                newState.responseCurrenciesList = []
            else
                newState.responseCurrenciesList = action.value;
            
            newState.responseCurrency = []
            break;
        case "CURRENCY_RESPONSE":
      
            newState.responseCurrency = action.value;
      
            break;
            
        default: 
            return newState;
    }

    return newState;
};

export default reducer;